import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postReportedProduct = (
    backend: string,
    token: string,
    employee_id: number,
    quantity: number,
    date: string,
    created_by_id: number,
    comment: string,
    product_assignment_id: number,
    product_id: number,
    project_id: number,
    customer_id: number,
    assignment_id: number,
    name: string,
    unit_id: string,
    sales_price,
    cost_price,
    salary_quantity?, 
    invoice_quantity?,
    project_variation_id?
) => {
    return fetch(
        `${getApiUrl(backend)}reported_products`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                employee_id,
                quantity,
                date,
                created_by_id,
                changed_by_id: created_by_id,
                comment,
                product_assignment_id,
                product_id,
                project_id,
                assignment_id,
                customer_id,
                name,
                unit_id,
                sales_price,
                cost_price,
                salary_quantity, 
                invoice_quantity,
                project_variation_id
            })
        }
    );
};

export default postReportedProduct;
